var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2Zm2.692 14.889a.59.59 0 0 0 .553.073.576.576 0 0 0 .362-.42c.435-2.042 1.489-7.211 1.884-9.068a.39.39 0 0 0-.129-.379.404.404 0 0 0-.399-.07c-2.096.776-8.553 3.198-11.192 4.175a.412.412 0 0 0 .025.781c1.184.354 2.738.847 2.738.847s.725 2.193 1.104 3.308a.431.431 0 0 0 .707.184l1.548-1.461s1.786 1.309 2.799 2.03Zm-5.505-4.338.84 2.769.186-1.754 5.092-4.593a.137.137 0 0 0 .017-.188.143.143 0 0 0-.188-.032l-5.947 3.798Z"
  })));
};
export default SvgLine;